// Labels, any of: suggested from the user's Jira as they type, or typed freely.
import { useState } from "react";

import { useT } from "../../../i18n";
import { ChipInput } from "../../../ui/ChipInput";
import { useJiraLabels } from "./useJira";

export function LabelsField({ credentialId, value, onChange }: { credentialId: string; value: string[]; onChange: (next: string[]) => void }) {
  const t = useT().tasks.create.jira;
  const [typed, setTyped] = useState("");
  const labels = useJiraLabels(credentialId, typed);
  return (
    <ChipInput
      label={t.labels}
      values={value}
      onChange={onChange}
      suggestions={(labels.data ?? []).map((l) => ({ value: l }))}
      onQuery={setTyped}
      placeholder={t.labelPlaceholder}
      valid={(v) => !/[\s,]/.test(v)}
      removeLabel={t.remove}
      status={labels.isError ? t.lookupFailed(labels.error.message) : t.labelsHint}
    />
  );
}
